import { FunctionComponent } from 'react';

import {
  SearchInput,
  Table,
  TableHeaderColumn,
} from '@kanda-libs/ks-component-ts';
import { FuseHit } from '@kanda-libs/ks-design-library';

import InfoBanner from 'components/shared/InfoBanner';

import { DEFAULT_COLUMN, TABLE_COLUMNS } from './constants';
import useUserTableProps from './useUserTableProps';

import { User } from '../UsersListPage/helpers';
import { ModalProps } from '../UsersListPage/useUsersListPage';

export interface UserTableProps {
  showHeader?: boolean;
  isLoading?: boolean;
  hits: FuseHit<User>[];
  query: string;
  setQuery: (query: string) => void;
  onRowClick: (props: ModalProps) => void;
}

const UserTable: FunctionComponent<UserTableProps> = function ({
  showHeader = true,
  isLoading = false,
  hits,
  query,
  setQuery,
  onRowClick,
}) {
  const tableProps = useUserTableProps(hits, query, isLoading, onRowClick);
  return (
    <>
      {showHeader && (
        <InfoBanner
          backArrow={false}
          title="Users"
          search={
            <SearchInput
              placeholder="Search users"
              query={query}
              onSearch={setQuery}
            />
          }
        />
      )}
      <Table
        {...tableProps}
        columns={TABLE_COLUMNS as unknown as TableHeaderColumn[]}
        defaultColumn={DEFAULT_COLUMN as TableHeaderColumn}
        hoverPopover={null}
      />
    </>
  );
};

export default UserTable;
